import { HouseholdMember, CertMember } from 'src/types/Certification';
import { ReactNode } from 'react';
import GoogleFontIcon from 'src/icons/GoogleFontIcon';
import SupportIcon from '@mui/icons-material/Support';
import PersonIcon from '@mui/icons-material/Person';
import type { Certification } from 'src/types/Certification';

export const getUserDisplayName = (
  member: Pick<HouseholdMember, 'first_name' | 'last_name'> | null | undefined
): string =>
  member?.first_name
    ? `${member.first_name} ${member.last_name || ''}`.trim()
    : 'User';

export const getUserInitial = (
  member: Pick<HouseholdMember, 'first_name'> | null | undefined
): string => (member?.first_name?.[0] || 'U').toUpperCase();

export function getMemberIcon(member: HouseholdMember | CertMember): ReactNode {
  // CertMember uses boolean flags; HouseholdMember uses member_type.display_name
  if ('is_head_of_household' in member) {
    if (member.is_head_of_household) {
      return <GoogleFontIcon name="crown" sx={{ fontSize: 22 }} />;
    }
    if (member.is_helper) {
      return <SupportIcon sx={{ fontSize: 22 }} />;
    }
    return <PersonIcon sx={{ fontSize: 22 }} />;
  }
  const memberTypeName = member.member_type?.display_name?.toLowerCase();
  if (memberTypeName === 'head of household') {
    return <GoogleFontIcon name="crown" sx={{ fontSize: 22 }} />;
  }
  if (memberTypeName === 'helper') {
    return <SupportIcon sx={{ fontSize: 22 }} />;
  }
  return <PersonIcon sx={{ fontSize: 22 }} />;
}

/** Count of pending signatures for a household member (same filter as member action logic). */
export function getMemberPendingSignatures(
  cert: Certification,
  memberId: number
): number {
  return (cert.form_signatures_request ?? [])
    .filter((fsr) => fsr.requested)
    .flatMap((fsr) =>
      (fsr.needed_signatures ?? []).filter(
        (sig) =>
          !sig.is_date &&
          !sig.is_name &&
          !sig.is_hhmt &&
          !sig.is_phone &&
          !sig.compliance &&
          !sig.signature_completed &&
          sig.household_member?.id === memberId
      )
    ).length;
}
